import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

const createScriptTag = (src, type) => {
  const script = document.createElement('script');
  script.src = src;
  if (type !== 'event') {
    script.crossOrigin = 'anonymous';
  }
  script.type = 'text/javascript';
  return script;
};

/**
 * It renders div and injects a script tag.
 * It is used to populate iframe with external forms (i.e. Everyaction)
 **/
export class Form extends PureComponent {
  /**
   * PropTypes
   * @property scriptSrc - script source to inject
   * @property embededElement - HTML content to inject
   * @property host - host document reference (should point to the iframe document if the form resides in the iframe)
   * @property hostWindow  - host window reference
   * @property type - type of the form
   * @property customClass - class added to the iframe content wrapper element
   **/
  static propTypes = {
    scriptSrc: PropTypes.string,
    embededElement: PropTypes.string,
    host: PropTypes.object,
    hostWindow: PropTypes.object,
    type: PropTypes.string,
    customClass: PropTypes.string,
  };

  componentDidMount() {
    const script = createScriptTag(this.props.scriptSrc, this.props.type);
    this.props.host.head.appendChild(script);
  }

  render() {
    const { type, embededElement, customClass } = this.props;

    return (
      <div
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: embededElement }}
        data-iframe-height
        className={customClass ? customClass : `form--${type}`}
      />
    );
  }
}
